import React, { useState } from "react";
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from "../../../config/ui.js";
import PAGES from "../../data/PagesConstants.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faCloudUpload, faFileCircleCheck } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from 'xlsx';

const COLUMN_NAMES = ["ID", "Name", "SLOC", "Serial Number", "Status"]; //Define acceptable column names.

const UploadFilesPage = () => {
    const [excelFile, setExcelFile] = useState(null);
    const [excelData, setExcelData] = useState(null);
    const [fileTypeError, setFileTypeError] = useState(null);
    const [fileMessage, setFileMessage] = useState("");
    const [fileUploaded, setFileUploaded] = useState(false);

    const handleFile = (e) => {
        let fileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
        let selectedFile = e.target.files[0];
        if (selectedFile) {
            if (selectedFile && fileTypes.includes(selectedFile.type)) {
                const fileSize = selectedFile.size / (1024 * 1024);
                if (fileSize < 5) {
                    setFileTypeError(null);
                    const fileName = e.target.value.split('\\').pop();
                    setFileMessage(fileName);

                    let reader = new FileReader();
                    reader.readAsArrayBuffer(selectedFile);
                    reader.onload = (e) => {
                        setExcelFile(e.target.result);
                        setFileUploaded(false);
                        const workbook = XLSX.read(e.target.result, { type: 'buffer' });
                        const worksheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[worksheetName];
                        const data = XLSX.utils.sheet_to_json(worksheet);
                        setExcelData(filterColumns(data.slice(0, 10)));
                    }
                } else {
                    setFileTypeError('Please select a file that is 5 MB or smaller.');
                    setExcelFile(null);
                    setExcelData(null);
                    setFileUploaded(false);
                }
            } else {
                setFileTypeError('Please select only excel file types.');
                setExcelFile(null);
                setExcelData(null);
                setFileUploaded(false);
            }
        } else {
            setFileMessage('No file selected');
            setFileUploaded(false);
        }
    }

    const handleFileSubmit = (e) => {
        e.preventDefault();
        if (excelFile !== null) {
            setFileUploaded(true);
            setExcelData(null);
            setExcelFile(null);
        }
    }

    const filterColumns = (data) => {
        return data.map(row => {
            const filteredRow = {};
            COLUMN_NAMES.forEach(column => {
                if (row.hasOwnProperty(column)) {
                    filteredRow[column] = row[column];
                }
            });
            return filteredRow;
        });
    }

    return (
        <Page
            uiPage={uiManager.getUiPage(PAGES.UploadFilesPage.name)}
            breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Upload Files" }]}
            className={'upload-files-config-page'}
        >
            <PageContentWrapper contentHeading={"Upload Files"}>
                <div className="d-flex justify-content-center mt-3">
                    <span><FontAwesomeIcon icon={faInfoCircle} className="me-1" /></span>
                    Accepted file types are .xls or .xlsx and maximum file size should be 5 MB or less.
                </div>
                <form className="form-group files" onSubmit={handleFileSubmit}>
                    <div className="file-drop-area">
                        <div style={{ fontSize: '50px', opacity: '20%' }} className="text-center">
                            <FontAwesomeIcon icon={excelFile ? faFileCircleCheck : faCloudUpload} />
                        </div>
                        <div className="text-center">
                            <span className="choose-file-button">
                                {excelFile ? "File Selected" : "Choose file"}
                            </span>
                            <span className="file-message">
                                {excelFile ? fileMessage : "or drag and drop file here"}
                            </span>
                        </div>
                        <input
                            type="file"
                            className="file-input"
                            multiple={false}
                            accept=".xls, .xlsx, .XLS, .XLSX, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            style={{ border: 'none' }}
                            onChange={handleFile}
                            required
                        />
                    </div>
                    <div className="text-center opacity-50">{fileUploaded ? "File Uploaded!" : "No File is Uploaded yet!"}</div>
                    <div className="d-flex justify-content-center mb-3">
                        <button
                            type="submit"
                            className="btn btn-sm btn-voltup-theme"
                        >
                            Upload
                        </button>
                    </div>
                    {fileTypeError && (
                        <div className="alert alert-danger" role="alert">{fileTypeError}</div>
                    )}
                </form>
                <React.Fragment>
                    <div className="wrapper mx-3">
                        <div className="viewer">
                            {excelData ? (
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                {COLUMN_NAMES.map((columnName, index) => (
                                                    <th key={index}>{columnName}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {excelData.map((individualExcelData, index) => (
                                                <tr key={index}>
                                                    {COLUMN_NAMES.map((columnName, index) => (
                                                        <td key={index}>{individualExcelData[columnName]}</td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="text-center pb-2 opacity-75">No File is selected yet, Please select the file!</div>
                            )}
                        </div>
                    </div>
                </React.Fragment>
            </PageContentWrapper>
        </Page>
    );
};

export default UploadFilesPage;
